"use client";

import { Analytics } from "@vercel/analytics/react";
import { CircleCheckBig } from "lucide-react";
import { AnimatePresence, motion } from "motion/react";
import { useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { getStoredConsent, setStoredConsent, updateGtagConsent } from "@/lib/consent";
import { cn } from "@/lib/utils";

export default function Tracking() {
  // undefined = not hydrated yet, null = no cookie, "granted" | "denied"
  const [consent, setConsent] = useState(undefined);

  useEffect(() => {
    setConsent(getStoredConsent());
  }, []);

  function handleConsent(status) {
    setConsent(status);
    setStoredConsent(status);
    updateGtagConsent(status);
  }

  const showBanner = consent === null;

  return (
    <>
      <AnimatePresence>
        {showBanner && (
          <motion.div
            className="fixed bottom-12 left-4 right-auto z-60 lg:bottom-4 lg:left-auto lg:right-4"
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 100 }}
            transition={{ duration: 0.3 }}
          >
            <div
              className={cn(
                "flex origin-bottom-left scale-[0.75] items-center justify-between gap-5 rounded-full border border-primary bg-primary py-3 px-6 text-white lg:scale-100 lg:gap-4 lg:py-3 lg:pl-4 lg:pr-8"
              )}
            >
              <button
                type="button"
                className="group cursor-pointer transition-all duration-500"
                onClick={() => handleConsent("granted")}
                aria-label="Accept cookies"
              >
                <CircleCheckBig className="h-11 w-11 group-hover:[&>path]:stroke-success-500" />
              </button>
              <div className="flex flex-col items-start gap-1 lg:gap-1">
                <p className="text-base font-semibold">This website uses cookies</p>
                <p className="text-sm text-light whitespace-nowrap">Click the tick to accept cookies or the buttons below</p>
                <div className="flex gap-3 mt-0.5">
                  <Button
                    variant="link-white"
                    onClick={() => handleConsent("granted")}
                    className="text-[15px]! !py-0 hover:underline text-white hover:!text-white/90"
                    aria-label="That's Ok"
                  >
                    That&apos;s Ok
                  </Button>
                  <Button
                    variant="link-white"
                    onClick={() => handleConsent("denied")}
                    className="text-[15px]! !py-0 hover:underline text-white/70 hover:!text-white"
                    aria-label="I wish to opt out"
                  >
                    I wish to opt out
                  </Button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <Analytics />
    </>
  );
}
